import { render, staticRenderFns } from "./GroupText.vue?vue&type=template&id=38a0a872&scoped=true&"
import script from "./GroupText.vue?vue&type=script&lang=js&"
export * from "./GroupText.vue?vue&type=script&lang=js&"
import style0 from "./GroupText.vue?vue&type=style&index=0&id=38a0a872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a0a872",
  null
  
)

export default component.exports